import { render, staticRenderFns } from "./CollegeAllTestReports.vue?vue&type=template&id=686d5997"
import script from "./CollegeAllTestReports.vue?vue&type=script&lang=js"
export * from "./CollegeAllTestReports.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports